
const Button = ({ type, width, height, handleClick, disabled, text }) => {

    let btnClass = 'text-slate-50 font-medium py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline cursor-pointer'
    btnClass += type === 'primary' ? ' bg-primary hover:bg-blue-700' : ' bg-red-500 hover:bg-red-700';
    btnClass += width ? ` ${width}` : '';
    btnClass += disabled ? ' opacity-50 pointer-events-none' : ' opacity-100 cursor-pointer';
    btnClass += height ? ` ${height}` : '';

    const handleClickButton = () => {
        if (handleClick) {
            handleClick();
        }
    }

    return (
        <button
            className={btnClass}
            onClick={handleClickButton}>
            {text}
        </button>
    )
};

export default Button;
